const Burger = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="16" width="24" height="4" fill="#6B2D2D" />
      <path
        d="M15.5 6H16.5C21.7467 6 26 10.2533 26 15.5H16L11.585 17.7075C11.2296 17.8852 10.8028 17.8357 10.4976 17.5813L8 15.5H6C6 10.2533 10.2533 6 15.5 6Z"
        fill="#F88531"
      />
      <path
        d="M8 26H24C25.1046 26 26 25.1046 26 24V20.5H6V24C6 25.1046 6.89543 26 8 26Z"
        fill="#F88531"
      />
      <path
        d="M8 15.5H6V15.5C6 10.2533 10.2533 6 15.5 6H16.5C21.7467 6 26 10.2533 26 15.5V15.5H16M8 15.5L10.4976 17.5813C10.8028 17.8357 11.2296 17.8852 11.585 17.7075L16 15.5M8 15.5H16M6 20.5V24C6 25.1046 6.89543 26 8 26H24C25.1046 26 26 25.1046 26 24V20.5H6Z"
        stroke="#222222"
        strokeWidth="2"
      />
      <path
        d="M28 18.5V17.5C28 16.3954 27.1046 15.5 26 15.5H25.5H6.5H6C4.89543 15.5 4 16.3954 4 17.5V18.5C4 19.6046 4.89543 20.5 6 20.5H6.5H25.5H26C27.1046 20.5 28 19.6046 28 18.5Z"
        stroke="#222222"
        strokeWidth="2"
      />
      <circle cx="20" cy="10" r="1" fill="#222222" />
      <circle cx="12" cy="10" r="1" fill="#222222" />
      <circle cx="16" cy="12" r="1" fill="#222222" />
      <path d="M14.5 15.5H9L11 17.5L14.5 15.5Z" fill="#FFE80F" />
    </svg>
  );
};

export { Burger };
